
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/aws-cloud-solutions",
      function () {
        return require("private-next-pages/services/aws-cloud-solutions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/aws-cloud-solutions"])
      });
    }
  